var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3936 26.1186C20.2996 26.1186 18.946 25.1202 18.286 23.8146L20.122 22.7512C20.6056 23.5408 21.2332 24.1205 22.3456 24.1205C23.2792 24.1205 23.8756 23.6534 23.8756 23.009C23.8756 22.0394 22.582 21.6605 21.6688 21.2693C20.0416 20.5769 18.9616 19.7069 18.9616 17.8697C18.9616 16.1789 20.2504 14.8902 22.2652 14.8902C23.698 14.8902 24.73 15.3894 25.4704 16.6938L23.7148 17.8217C23.3284 17.1293 22.9096 16.8555 22.2652 16.8555C21.604 16.8555 21.1852 17.2745 21.1852 17.8217C21.1852 18.4985 21.604 18.7722 22.5712 19.191C24.598 20.0598 26.1316 20.7424 26.1316 22.9768C26.1316 25.0072 24.5368 26.1186 22.3936 26.1186ZM17.2 22.7189C17.2 25.0553 15.7612 26.2902 13.7632 26.2902C11.9584 26.2902 10.8772 25.6 10.3456 24.4H10.3276H10.3192H10.3144L12.1492 23.1174C12.5032 23.745 12.8224 24.1902 13.5952 24.1902C14.3368 24.1902 14.8 23.8147 14.8 22.6879V14.8H17.2V22.7189ZM4 28H28V4H4V28Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.ee118015ad533722e369af82b0d5300b.svg";
export { ForwardRef as ReactComponent };